import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  MoreOutline,
  EyeInvisibleOutline,
  InfoCircleFill,
  CloseOutline,
  LoadingOutline,
  Loading3QuartersOutline
} from '@ant-design/icons-angular/icons';

export const icons = [MenuFoldOutline, MenuUnfoldOutline, DashboardOutline, FormOutline, MoreOutline, EyeInvisibleOutline, InfoCircleFill, CloseOutline, LoadingOutline, Loading3QuartersOutline];
